module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_4.f69cef96.png";